import { isNil } from 'ramda';

function formatNumber(
  number,
  // eslint-disable-next-line default-param-last
  formatUpTo = 0,
  countryCode,
  formatToDecimalPlaces = false
) {
  if (isNil(number)) return null;

  if (!countryCode) return Number(Number(number).toFixed(formatUpTo));

  const options = {
    style: "decimal",
    minimumFractionDigits: formatUpTo,
    maximumFractionDigits: formatUpTo
  };

  // don't add trailing 0s if it's an integer
  if (!formatToDecimalPlaces && Math.ceil(number) === Math.floor(number))
    options.minimumFractionDigits = 0;

  const formatter = new Intl.NumberFormat(countryCode, options);
  return formatter.format(number);
}

export default formatNumber;
